import { render, staticRenderFns } from "./attorney.vue?vue&type=template&id=6f91cbc1"
import script from "./attorney.vue?vue&type=script&lang=js"
export * from "./attorney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports